import { useTranslation } from 'react-i18next'

const RacistTeacherStart = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="racist-teacher-start-title"
      {...props}
    >
      <title id="racist-teacher-start-title">{t('antagonists:racistteacher:components:start')}</title>
      <path
        d="M1658.09 566.81s2.74 19.46.07 28.49c-2.67 9.03-7.93 22.43-7.71 27.34.21 4.91.94 28.95.94 28.95s4.99.6 7.6-3.49c2.61-4.09 1.54-14.95 2.14-17.2.6-2.25 2.47-2.71 3.39 1.04s1.74 14.9.85 16.9c-.9 2.01-5.99 5.66-5.86 9.76.13 4.1 5.4 7.82 5.4 7.82s3.29-2.79 11.49-8.53c8.2-5.74 10.89-9.02 12.25-11.89 1.36-2.87 5.87-4.41 6.44-6.94s1.93-22.11-.78-27.32c-2.71-5.21-6.71-12.49-6.57-19.35s-2.54-31.26-2.54-31.26l-27.11 5.69Z"
        style={{
          fill: '#e3b67d',
        }}
      />
      <path
        d="M1624.25 332.9c-23.14 7.36-19.36 73.89-10.91 99.79 8.45 25.9 16.95 45.57 30.72 64.14 13 17.52 38.19 1.46 40.92-14.62 2.73-16.09-7.29-33.16-18.74-69.97s-21.27-73.35-27.27-76.89c-6-3.54-8.73-4.36-14.72-2.45Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1632.7 476s2.62 12.78 5.85 37.12c3.22 24.34 4.63 50.5 9.15 57.45 4.52 6.95 8.33 11.22 8.33 11.22l1.18 11.92s7.17.7 17.04.83 15.03-3.13 15.03-3.13l-.44-18.31s7.51 3.92 6.45-12.42c-1.06-16.33-.57-66.69-11.44-93.57-10.87-26.87-16.69-25.03-38.6-16.57s-15.66 16.18-12.55 25.47Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1624.34 923.73s2.26 12.31-1.01 23.87c-3.27 11.56-1.51 24.13-1.51 24.13s33.68-2.76 33.93-3.52 3.11-12.79 1.61-17.56c-1.51-4.77-4.37-9.08-5.38-14.36s-.75-24.88-.75-24.88l-26.89 12.31Z"
        style={{
          fill: '#00a39a',
        }}
      />
      <path
        d="M1636.15 943.33c-10 .38-14.83 14.32-15.58 14.32s0 11.06-3.77 19.85c-3.77 8.8-6.79 22.37-7.04 26.64s.5 11.06.5 11.06 27.14 6.79 39.2 2.76c12.06-4.02 15.58-8.29 15.58-8.29s.5-7.79-.5-19.85c-1.01-12.06-1.26-20.36-1.26-24.88s-6.39-16.67-6.81-16.61 3.04 9.07-1.49 8.82c-4.52-.25-5.53-14.32-18.85-13.82Z"
        style={{
          fill: '#f5f2ed',
        }}
      />
      <path
        d="M1501.2 903.63s-2.01 11.06 0 21.11c2.01 10.05 5.28 21.61 5.28 21.61l-43.23 18.35-6.03-19.35s13.57-9.05 13.82-20.86c.25-11.81 1.01-28.15 1.01-28.15l29.15 7.29Z"
        style={{
          fill: '#00a39a',
        }}
      />
      <path
        d="M1505.7 932.02h-2.96s2.34 9.82-2.55 11.17c-4.89 1.35-19.63-4.79-19.63-4.79s2.71-5.2-.33-8.23c-3.04-3.04-11.47-5.74-11.47-5.74s-12.48 10.8-19.57 22.1-7.09 15.69-12.82 18.22c-5.74 2.53-18.22 7.76-20.41 11.81-2.19 4.05-1.46 17.15-1.46 17.15s18.33 1.58 36.71-2.14c18.39-3.71 22.94-6.92 31.88-8.77s13.16-1.18 21.09-3.37c7.93-2.19 13.33-4.72 13.33-4.72s0-14.17-2.53-21.26c-2.39-6.7-3.37-11.81-4.89-15.18-1.52-3.37-4.22-6.24-4.39-6.24Z"
        style={{
          fill: '#f5f2ed',
        }}
      />
      <path
        d="M1539.39 295.33c-29.37 0-49.21 14.75-58.22 24.12s-2.51 41.69-2.51 41.69l55.86 37.12 64.87-81.08s-6.07-4.14-7.87-9.9c-1.8-5.77-3.44-8.56-14.62-10.72-11.17-2.16-36.79-1.22-37.51-1.22Zm-77.95 232.37s-2.18 20.21-7.1 35.5-7.1 42.06-9.29 60.63c-2.18 18.57 1.09 66.64 2.73 111.97 1.64 45.34 10.38 145.84 12.02 158.95 1.64 13.11 2.18 22.94 2.18 22.94s7.65 7.1 18.57 6.55c10.92-.55 24.03-.55 24.03-.55l2.73-15.84s7.65-.55 8.19-17.48c.55-16.93-6.55-135.46-6.01-149.66.55-14.2 33.87-115.8 32.23-115.8s-12.56-99.41-12.56-99.41l-67.73 2.18Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1481.65 546.82c.55 1.64 65.55 158.4 72.1 178.07 6.55 19.66 21.3 45.34 21.85 54.62s21.85 121.81 26.76 131.09c4.92 9.29 13.66 12.02 13.66 12.02l2.73 16.39s13.11-.55 23.49-2.18c10.38-1.64 19.12-6.01 19.12-6.01l-3.28-14.75s4.92-8.19 3.28-14.2c-1.64-6.01-34.41-137.65-36.05-157.31-1.64-19.66-8.74-100.5-9.83-126.18-1.09-25.67-20.21-65-25.13-77.02-4.92-12.02-31.68-30.59-31.68-30.59l-77.02 36.05Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1488.39 265.27s10.94 30.04 12.97 41.08c2.31 12.51-2.16 27.75-2.16 27.75s11.17 21.62 12.61 21.26 68.83-36.04 68.83-36.04l-14.05-8.65s-7.57-.72-9.73-11.53-6.85-40-6.85-40l-61.62 6.13Z"
        style={{
          fill: '#e3b67d',
        }}
      />
      <path
        d="M1521.55 335.91c11.81-1.75 29.19-14.05 33.87-19.46 4.68-5.41 5.16-9.67 5.16-9.67l14.62 3.17-45.72 94.79-66.31-32.07 1.8-22.34 36.36-27.63s.76 16.1 20.22 13.21Z"
        style={{
          fill: '#f3faf9',
        }}
      />
      <path
        d="M1455.24 353.92c-9.01 5.77 2.88 30.99 5.77 56.94 2.88 25.95 12.97 57.3 0 71.71-12.97 14.41-16.08 27.15-14.27 39.05s3.46 19.33 6.71 22.58l6.13 6.13-4.68 15.86s21.98 14.78 52.97 9.73c30.99-5.05 52.61-11.89 69.91-10.81 17.3 1.08 25.23 2.52 25.23 2.52l.36-14.05s8.29 3.24 10.45-7.93-1.84-55.72 4.65-78.78c6.49-23.06 37.32-112.65 24.71-125.98-12.61-13.33-31.52-19.39-40.89-23.71-9.37-4.32-32.07-17.66-32.07-17.66s-7.21 28.47-21.98 40.36c-14.78 11.89-32.07 37.84-32.07 37.84s-14.41-16.58-19.1-30.99c-4.68-14.41-4.68-23.06-4.68-23.06s-3.6 7.93-12.61 13.69c-9.01 5.77-24.51 16.58-24.51 16.58Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#a)',
        }}
      >
        <path
          d="M1512.54 366.9s5.41 29.91 1.8 43.24c-3.6 13.33-10.45 45.41-11.53 64.51-1.08 19.1-7.21 64.87-6.13 75.68 1.08 10.81 5.05 9.37 5.05 16.22s-.36 13.69-.36 13.69h6.13v-14.41c0-6.85-3.24-7.57-4.68-15.86-1.44-8.29 3.6-64.87 5.77-77.12 2.16-12.25 7.21-47.93 10.81-62.7 3.6-14.78-2.88-44.69-2.88-44.69l-3.96 1.44Z"
          style={{
            fill: '#006ab3',
          }}
        />
      </g>
      <path
        d="M1455.24 353.92c-11.91 6.77-9.73 41.08-12.97 63.79s-21.88 65.43-22.96 75.88c-1.08 10.45 13.35 30.57 18.04 32.38 4.68 1.8 31.91 5.55 31.91 5.55l18.05-133.27s-11.17-56.22-32.07-44.33Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1530.86 196.65c10.95-.27 22.44 3.56 28.19 12.86 5.75 9.31 6.84 20.25 5.47 30.66-1.37 10.4-4.11 26.28-4.11 26.28h-72.26s-1.37-10.95-3.01-18.34c-1.64-7.39 0-14.51 1.37-24.36s4.38-16.97 13.41-22.17c9.03-5.2 30.93-4.93 30.93-4.93Z"
        style={{
          fill: '#e17136',
        }}
      />
      <path
        d="M1519.64 225.39c11.29.66 26.28-4.65 28.47.82 2.19 5.47 2.46 16.7 2.46 16.7s7.39 0 6.3 6.57.55 12.32.55 12.32 2.19-5.2 7.39-4.11 3.28 8.76 1.09 15.05c-2.19 6.3-4.65 13.96-7.39 13.96s-6.02-2.19-6.02-2.19-3.56 12.86-7.66 18.89c-4.11 6.02-14.78 10.67-20.8 11.77-6.02 1.09-18.89-.82-22.72-4.38-3.83-3.56-10.13-12.59-11.77-16.7-1.64-4.11-1.37-12.32-1.37-12.32s-3.01 3.28-5.47-1.92c-2.46-5.2-4.65-26.55-.82-25.73 3.83.82 5.47 1.64 5.47 1.64s-.82-7.94.27-11.22c1.09-3.28 4.11-7.39 6.02-13.14 1.92-5.75 3.56-12.04 8.21-11.77s13.14 5.47 17.79 5.75Z"
        style={{
          fill: '#e3b67d',
        }}
      />
      <path
        d="M1528.76 293.66c-.87.76-1.74.05-3.94.44s-4.46 2.35-9.24 1.72-8.07-3.37-9.71-3.05-2.74.78-3.21-.39 7.05-6.34 9.01-6.03c1.96.31 3.45 1.96 4.46 2.04s2.4-1.03 3.73-1.11 4.94.87 7.26 2.42c1.2.8 2.9 2.87 1.65 3.97Z"
        style={{
          fill: '#d88b46',
        }}
      />
      <path
        d="M1511.12 245.23s-5.64-.7-8.62-2.43-5.87-2.98-7.52-2.66c-1.64.31-4.86 3.13-4.86 3.13l.39 1.49s3.92-1.8 4.78-1.25 4.39 3.05 7.83 4.39c3.45 1.33 6.97 2.04 6.97 2.04l1.02-4.7Zm11.87 5.12-1.17-5.48s4.62 2.11 8.93.39c4.31-1.72 7.28-2.9 9.48-2.27 2.19.63 6.03 4.86 6.03 4.86l-1.25 1.72s-2.58-3.92-6.27-2.51c-3.68 1.41-4.53 2.19-8.22 2.9-4.06.77-7.52.39-7.52.39Z"
        style={{
          fill: '#e17136',
        }}
      />
      <path
        d="M1531.47 254.22c-2.27.13-3.78 1.76-3.56 3.98.22 2.22 1.71 3.04 3.76 3.05 2.41.01 3.7-1.52 3.71-3.83 0-1.63-1.57-3.34-3.91-3.2Z"
        style={{
          fill: '#204a68',
        }}
      />
      <path
        style={{
          fill: '#204a68',
        }}
        d="m1528 257.5 11.09-1.28-.22-4.05-11.51 2.55.64 2.78zm-26.53-4.6c2.18-.64 4.15.39 4.69 2.55.54 2.16-.59 3.44-2.51 4.13-2.27.82-4-.19-4.78-2.36-.55-1.53.36-3.67 2.6-4.32Z"
      />
      <path
        style={{
          fill: '#204a68',
        }}
        d="m1505.92 256.54-10.39-2.41.15-4.06 11.38 3.29-1.14 3.18z"
      />
      <path
        d="M1520.69 189.18c13.17.33 25.06 4.39 30.3 8.04 5.23 3.66 13.03 17.24 14.63 29.17s.17 21.17.17 21.17h-2.68s-17.05-15.84-48.16-16.45c-20.31-.4-29.96 8.27-29.96 8.27l-4.68 1.26s.48-10.74 1.46-20.18 2.42-16.55 9.75-20.71c7.34-4.16 24.24-10.7 29.17-10.58Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="m1517.57 202.45-.91 9.78s-5.14-.27-7.95-.32-7.13 1.04-7.13 1.04l.42-9.51s3.89-.93 7.13-1.04c3.28-.11 8.44.05 8.44.05Z"
        style={{
          fill: '#e2007a',
        }}
      />
      <path
        d="M1561.03 243.29s-1.82 10.19-13.9 7.56c-12.9-2.81-23.14-14.08-43.24-13.79-14.45.21-18.97 4.45-23.5 7.88-4.41 3.33-10.88 9.49-12.91 6.99-1.44-1.78 7.11-8.44 11.41-11.59 4.26-3.12 16.62-11.7 34.5-11.64 26.56.09 47.64 14.59 47.64 14.59Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1444.79 495.55c-8.29 2.07-6.85 19.46-6.13 23.42s7.57 4.32 9.73 5.77 4.5 4.23 4.5 4.23-3.06-7.47-1.26-15.4c1.8-7.93 6.85-16.22 6.85-16.22s-5.05 1.8-7.57 0c-2.52-1.8-3.24-2.52-6.13-1.8Z"
        style={{
          fill: '#e3b67d',
        }}
      />
      <path
        d="M1509.1 298.87c-2.41 7.84 4.5 17.67 4.5 17.67l6.68.27s.28-5.09 2.12-10.14c1.37-3.77.23-7.57.23-7.57l-13.53-.23Z"
        style={{
          fill: '#e17136',
        }}
      />
    </svg>
  )
}

export default RacistTeacherStart
